import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {CommandUtil} from '../../../../global/commandutil';
import {ChenHoSoVanBanDenComponent} from '../chenhoso/chenhoso.component';
import {FormatService} from '../../../../service/format/service-format';
import {DatePipe} from '@angular/common';
import {TongHopYKienVanBanDenComponent} from '../xuly/tonghop.component';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
import {DMNguon} from '../../../../models/danhmuc/dmnguon';
import {DMNguonService} from '../../../../service/danhmuc/service-dmnguon';
@Component({
  templateUrl: './vbphocap.component.html',

})
export class VBPhoCapComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public dataList: VanBanDen[];
  public submitValidate = false;
  public dateCurrent: Date = new Date();
  public permission: boolean = false;
  public srTuKhoa: string = '';
  public srStatus: string ='';
  public status: number[] = [
   environment.chuaxuly, environment.dangxuly, environment.hoanthanh, environment.chogiaoxuly, environment.khongxuly
  ];
  public phoCap: number = 1;
  public nguoiNhapId: number = -1;
  public nguoiChuTri: number =-1;
  public maNoiGui: number =-1;
  public checked: boolean = false;
  public dataCheck: Object[]=[];
  public srFromDate: Date ;
  public srToDate: Date;
  public strF: string= '';
  public strT: string= '';
  public dataLoaiVanBan: LoaiVanBan[] = [];
  public srLoaiVanBan: number =-1;
  public srLinhVucVanBan: number =-1;

  private dataDMNguon: DMNguon[] = [];
  private searchTuongDoi: number = environment.SEARCH_TUONGDOI;
  private searchChinhXac: number = environment.SEARCH_CHINHXAC;
  private srNguonVanBan : string = environment.SEARCH_ALL;
  private srSearchType: number = environment.SEARCH_TUONGDOI;

  constructor(
    public vanBanDenService: VanBanDenService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public commandUtil: CommandUtil,
    public formatService: FormatService,
    public datePipe: DatePipe,
    public navItemService: NavItemService,
    public loaiVanBanService: LoaiVanBanService,
    public rolePermissionService: RolePermissionService,
    public dmNguonService: DMNguonService

  ) {
  }
  ngAfterViewInit() {

  }
  public yKienTongHop(id: number) {
    const modalEdit = this.bsModalService.show(TongHopYKienVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopYKienVanBanDenComponent>modalEdit.content).edit(
      id
    );
    (<TongHopYKienVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }

  ngOnInit(): void {
    this.srStatus = this.status.join();
    this.formatService.getCurrentDateVN().subscribe(x => {
      this.dateCurrent = this.commandUtil.getDate(x);
    });
;
    this.search();
    this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);
    this.dmNguonService.getAll().subscribe( data  => this.dataDMNguon = data);
  }
  public chenHoSo(id: number) {
      const modalEdit = this.bsModalService.show(ChenHoSoVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<ChenHoSoVanBanDenComponent>modalEdit.content).edit(
        id
      );
      (<ChenHoSoVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {

      });
  }
  get f() { return this.frmGroup.controls; }
  search()
  {

    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.vanBanDenService.findAllByVBTypePaging(this.srTuKhoa, this.srSearchType, this.srNguonVanBan,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiNhapId,
      this.nguoiChuTri,
      this.maNoiGui, this.strF, this.strT,
      this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.vanBanDenService.getCountByVBTypeSearch(this.srTuKhoa, this.srSearchType, this.srNguonVanBan,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiNhapId,
      this.nguoiChuTri,
      this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalItems = recordCount);
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

